import AttributeEdit from "../grid/Attributeedit/src/AttributeEdit";
import React, { Component } from "react";
import { observer } from "mobx-react";
import OverrideDefaults from "./OverrideDefaults";
const skipString = "skip";
const toChoices = (
  strings, //label
  startInt //Startint fpr den Offset, für die Einzigartigkeit der Values in allen möglichen Choices der Dropdowns
) => {
  return strings.map((str, i) => {
    if (typeof str === "object") {
      //Object für zusätzliche Eigenschaften, ggf. für andere Widgets abfragbar (bspw. "short" für den KlimaSlider)
      const newObj = JSON.parse(JSON.stringify(str)); //Object copy, not reference (schwieriger Bug..)
      newObj.value = startInt + i;
      return newObj;
    }
    return {
      label: str,
      value: startInt + i, //mit OIffset
    };
  });
};
class Filter extends Component {
  getTreeAttributes(theme) {
    const { level, tree } = theme;
    const { infos = {} } = this.props;
    return level.map((l, i) => {
      //für jede Ebene ein DropDown Attribut
      //möglichkeit: Erweiterung für andere AttributArten

      return {
        id: l,
        type: "dropDown",
        visible: i === 0,
        placeholder: "Auswahl",
        attributeOption: {
          choices: i === 0 ? toChoices(Object.keys(tree[level[0]])) : [],
          placeholder: "Auswahl",
          InputLabelProps: {
            style: {
              fontSize: "20px",
              top: "7.5px",
              left: "-14px",
            },
          },
        },
        rules: this.getRules(l, infos),
      };
    });
  }
  getRules(levelKey, infos) {
    if (infos[levelKey]) {
      return [
        {
          condition: {
            boolConstant: false,
          },
          ifViolatedType: "message",
          ifViolatedText: infos[levelKey],
        },
      ];
    }
    return [];
  }

  isSkipped(value, attributeStore, attributeId) {
    // wenn das DropDown mit der AttributeID momentan nur eine auswahl "skip" hat (skipString)
    // wird es übersprungen
    const { skipAlways = [] } = this.props;
    return (
      skipAlways.indexOf(attributeId) !== -1 ||
      attributeStore?.updateOptions?.choices?.[0]?.label === skipString
    );
  }

  /**
   *
   * @param {Array} level
   * @returns Dependencie Konfiguration für die Sichtbarkeit der einzelnen Filterdropdowns für das attribute-edit
   */
  getVisibilityDependencies(level) {
    // return [];
    return level.slice(1).map((l, i) => {
      //gehe alle attribute der Level, außer das erste, durch
      return {
        triggerCondition: {
          // Bedingung für die sichtbarkeit
          and: level //Alle vorigen Attribute müssen "gefüllt" sein (es sei denn, sie sind geskippt)
            // & das attribute selber wird nicht angezeigt, wenn es übersprungen wird
            .slice(0, i + 1)
            .map((sl) => {
              return {
                or: [
                  {
                    atom: {
                      attribute: sl, //voriges Attribute
                      filled: true, //ist ausgefüllt (hat einen wert)
                    },
                  },
                  {
                    atom: {
                      attribute: sl, //oder dieses vorige Attribut
                      customFunction: this.isSkipped.bind(this), // wird übersprungen
                    },
                  },
                ],
              };
            })
            .concat([
              {
                not: {
                  atom: {
                    attribute: l, // das attribut
                    customFunction: this.isSkipped.bind(this), //wird momentan übersprungen
                  },
                },
              },
            ]),
        },
        effects: [
          {
            display: [l], //Zeige Attribut l an
          },
        ],
      };
    });
  }

  /**
   *
   * @param {*} tree Filterbaum
   * @param {*} level Ebenen des Filterbaums mit ID
   * @returns Abhängigkeiten (ohne Sichtbarkeitsabhängigkeiten) zwischen den Filter ebenen für das Attribut-Edit
   */
  getTreeDependenciesStart(tree, level) {
    this.usedIndices = {};
    level.forEach((l) => (this.usedIndices[l] = 1)); //für die Offset-berechnung (die Möglichkeiten sollen in jedem unterbaum einen einzigartigen Value haben)
    // Das bedeutet, eine Jahresangabe "1930" unter einem Jahresabschnitt "Sommerhalbjahr"
    // soll einen anderen Value haben, als die Jahreszahl "1930" unter dem Jahresabschnitt "Jahr"
    return this.getTreeDependencies(tree, level, 0, []); //Rekursionsstart
    // tree: der gesamte Filterbaum
    // Level: Array mit IDs der Ebenen
    // 0: index des Levels
    // []: bisherig erzeugte bedingungen
    // Wichtig für tiefere Anzeigen:
    // Für die Möglichkeiten der Auswahl der Jahreszahlen (Klimaviewer) ist nicht nur der Jahresabschnitt wichtig
    // Sondern  auch alle Auswahlen vorher!
  }

  /**
   *
   * @param {object} node momentan betrachter Knotne im Filterbaum
   * @param {Array} level Ebenen des
   * @param {int} index momentane Ebene im Filterbaum bzw. index im Ebenen-Array
   * @param {array} ands bis jetzt aufgebaute Abhängigkeiten.
   * Das ands-Array ist notwendig, da nicht nur die lokale änderungen im Filter Baum abgebildet werden müssen
   * Es kann auch sein, dass ein anderer Eintrag mehrere Ebenen darüber für einen anderen Eintrag auf der Ebene sorgt.
   * Entsprechend muss für eine Abhängigkeit für den momentanen Knoten im Filter Baum auch der "Weg" zu diesem Knotne berücksichtigt werden.
   * (Dadurch kommt es btw. zu einer exponentiell wachsenden menge an abhängigkeiten bzgl der Anzahl der Ebenen, also beware)
   * @returns Abhängigkeits Kofniguration für den Aktuellen knoten "node" mit berücksichtigung des ands- array was bis zu diesem Knoten schon aufgebaut wurde
   */
  getTreeDependencies(node, level, index, ands) {
    // wenn es keine Ebenen mehr für die Abhängigkeiten gibt, gibt es keine Abhängigkeiten zu konfigurieren
    if (index >= level.length) {
      return [];
    }
    let dependencies = [];
    const oneStep = (choices, choiceNode, choiceIndex) => {
      // jeder Attribut-key eines Knotens ist gleichzeitig ein Eintrag des übergeordneten Drop downs.
      // Wird also auf der übergeordneten Ebene ein Eintrag ausgewählt, müssen die Auswahlmöglichkeiten auf der momentanen Ebene
      // gesetzt werden, auf die Keys des objekts.
      const newands = ands.concat(
        index > 0
          ? [
            {
              atom: {
                attribute: level[index - 1], //id der übergeordneten ebene (node-ebene)
                equals:
                  this.usedIndices[level[index - 1]] - //indizeverschiebung (um unterschiedliche Indizes in einer Ebene zu erhalten)
                  choices.length +
                  choiceIndex, // Indize des childkeys auf der node-ebene
              },
            },
          ]
          : []
      );

      const defaultValEffect = choiceNode?.default
        ? [
          {
            customAttributes: [level[index]],
            customFunction: (attributeStore) => {
              const defaultValue =
                OverrideDefaults[attributeStore.targetConfig.id] ||
                choiceNode?.default;
              if (defaultValue) {
                const { choices = [] } = attributeStore.updateOptions || {};
                const index = choices
                  .map((c) => c.label)
                  .indexOf(defaultValue);
                if (index !== -1) {
                  attributeStore.setValue(choices[index].value);
                }
              }
            },
          },
        ]
        : [];
      dependencies.push({
        triggerCondition: {
          and: newands, //ands + bedingung für genau diesen eintrag des knotens
        },
        effects: [
          {
            attributeOptions: {
              // neue attributeOptionen für die betreffenden IDs (neue choices)
              id: level[index], // ID des Drop-Downs für die Ebene
              options: {
                choices: choiceNode.choices //bei Blättern
                  ? toChoices(
                    choiceNode.choices,
                    this.usedIndices[level[index]]
                  )
                  : toChoices(
                    Object.keys(choiceNode),
                    this.usedIndices[level[index]]
                  ),
              },
            },
          },
          // this.customAttributes.forEach(d => {
          //   this.customFunction(
          //     this.DataStore.attributeValues[d],
          //     true,
          //   );
        ].concat(defaultValEffect),
      });
      this.usedIndices[level[index]] = //Update der benutzten Indizes, für den Offsetr der Values bei den Dropdowns, damit jede Möglichkeit einen einzigartigen Value hat
        this.usedIndices[level[index]] + //bisherig benutzten Values
        (choiceNode.choices // + die neuen mlglichkeiten
          ? choiceNode.choices.length
          : Object.keys(choiceNode).length);
      dependencies = dependencies.concat(
        this.getTreeDependencies(choiceNode, level, index + 1, newands) //Rekursion mit nächstem Knoten
      );
    };
    if (node.choices) {
      node.choices.forEach((choice, i) => oneStep(node.choices, choice, i));
    } else {
      Object.keys(node).forEach((childKey, i) =>
        oneStep(Object.keys(node), node[childKey], i)
      );
    }
    Object.keys(node).forEach((childKey, childKeyIndex) => {
      // // jeder Attribut-key eines Knotens ist gleichzeitig ein Eintrag des übergeordneten Drop downs.
      // // Wird also auf der übergeordneten Ebene ein Eintrag ausgewählt, müssen die Auswahlmöglichkeiten auf der momentanen Ebene
      // // gesetzt werden, auf die Keys des objekts.
      // const newands = ands.concat(
      //   index > 0
      //     ? [
      //         {
      //           atom: {
      //             attribute: level[index - 1], //id der übergeordneten ebene (node-ebene)
      //             equals:
      //               this.usedIndices[level[index - 1]] - //indizeverschiebung (um unterschiedliche Indizes in einer Ebene zu erhalten)
      //               Object.keys(node).length +
      //               childKeyIndex, // Indize des childkeys auf der node-ebene
      //           },
      //         },
      //       ]
      //     : []
      // );
      // dependencies.push({
      //   triggerCondition: {
      //     and: newands, //ands + bedingung für genau diesen eintrag des knotens
      //   },
      //   effects: [
      //     {
      //       attributeOptions: {
      //         // neue attributeOptionen für die betreffenden IDs (neue choices)
      //         id: level[index], // ID des Drop-Downs für die Ebene
      //         options: {
      //           choices: node[childKey].choices //bei Blättern
      //             ? toChoices(
      //                 node[childKey].choices,
      //                 this.usedIndices[level[index]]
      //               )
      //             : toChoices(
      //                 Object.keys(node[childKey]),
      //                 this.usedIndices[level[index]]
      //               ),
      //         },
      //       },
      //     },
      //   ],
      // });
      // this.usedIndices[level[index]] = //Update der benutzten Indizes, für den Offsetr der Values bei den Dropdowns, damit jede Möglichkeit einen einzigartigen Value hat
      //   this.usedIndices[level[index]] + //bisherig benutzten Values
      //   (node[childKey].choices // + die neuen mlglichkeiten
      //     ? node[childKey].choices.length
      //     : Object.keys(node[childKey]).length);
      // dependencies = dependencies.concat(
      //   this.getTreeDependencies(node[childKey], level, index + 1, newands) //Rekursion mit nächstem Knoten
      // );
    });
    return dependencies;
  }

  getConfig(props) {
    const { general, themes, root, tree, level } = props;
    return {
      // debug: true,
      title: general.title,
      themesOptions: {
        displayStyle: "accordeon", //anzeige als akkordeon
        themes: themes
          ? themes.map((t) => {
            return {
              title: t.title, // Übernahme der Konfiguration
              alwaysOpen: t.alwaysOpen,
              attributes: t.root
                ? this._getAttributes(t.root) //umständlicher
                : this.getTreeAttributes(t),
            };
          })
          : [
            {
              title: general.subtitle,
              alwaysOpen: true,
              attributes: root
                ? this._getAttributes(root)
                : this.getTreeAttributes(this.props),
            },
          ],
      },
      dependencyOptions: {
        dependencies: themes
          ? themes //wenn es mehrere Themen gibt
            .map((t) =>
              t.root
                ? this._getDependencies(t.root) //Veraltet
                : this.getTreeDependenciesStart(t.tree, t.level).concat(
                  //empfohlen
                  this.getVisibilityDependencies(t.level)
                )
            )
            .flat()
          : (root
            ? this._getDependencies(root) //veraltet
            : this.getTreeDependenciesStart(tree, level)
          ) //empfohlen
            .concat(this.getVisibilityDependencies(level)),
      },
    };
  }
  _getAttribute(attributeConf) {
    attributeConf.type = attributeConf.type || "dropDown";
    attributeConf.attributeOption = { choices: attributeConf.choices };
    return attributeConf;
  }

  _getAttributes(root) {
    let attributes = [];
    if (root.attribute) {
      attributes.push(this._getAttribute(root.attribute));
    }
    if (root.children) {
      Object.keys(root.children).forEach(
        (c) =>
        (attributes = attributes.concat(
          this._getAttributes(root.children[c])
        ))
      );
    }
    return attributes;
  }
  _getTrigger(root, childKey) {
    if (root.getChild) {
      return {
        atom: {
          customFunction: (val) => root.getChild(val) === childKey,
          customFunctionAttribute: root.attribute.id,
        },
      };
    } else if (root.childInvertedAssignment) {
      return {
        or: root.childAssignment[childKey].split(",").map((val) => {
          return {
            atom: {
              attribute: root.attribute.id,
              equals: val,
            },
          };
        }),
      };
    } else if (root.childAssignment) {
      //val1: "id1, id2"
      const vals = Object.keys(root.childAssignment).filter(
        (val) => root.childAssignment[val].split(",").indexOf(childKey) !== -1
      );
      return {
        or: vals.map((val) => {
          return {
            atom: {
              attribute: root.attribute.id,
              equals: val,
            },
          };
        }),
      };
    } else if (root.childRequestKey) {
      //TODO
    }
    return {
      atom: {
        attribute: root.attribute.id,
        filled: true,
      },
    };
  }
  _getDependencies(root) {
    let dependencies = [];
    if (root.attribute && root.children) {
      if (root.children.childAttribute) {
        Object.keys(root.children).forEach((k) => {
          if (k !== "childAttribute") {
            const effect = {
              attributeOptions: {
                id: root.children.childAttribute.attribute.id,
                options: root.children[k],
              },
            };
            dependencies.push({
              triggerCondition: this._getTrigger(root, k),
              effects: [effect],
            });
          }
        });
      } else {
        Object.keys(root.children).forEach((k) => {
          const effect = {
            display: [root.children[k].id],
          };
          dependencies.push({
            triggerCondition: this._getTrigger(root, k),
            effects: [effect],
          });
        });
      }
    }
    return dependencies;
  }

  render() {
    return (
      <AttributeEdit
        config={this.getConfig(this.props)}
        requestStore={this.props.RequestStore}
        registerDataStore={this.props.CommunicationStore} //dorthin soll der DataStore des AttributeEdits eingespeißt werden
        {...this.props}
      />
    );
  }
}
export default observer(Filter);
